import { Link } from "react-router-dom";
import "./NewBornInfo.css";

export default function NewBornInfo(props) {
  return (
    <main className="nbx">
      {/* HERO */}
      <section className="nbx-hero">
        <div className="container">
          <h1 className="nbx-title">Đặc Điểm Nổi Trội của Sản Phẩm</h1>
          <p className="nbx-sub">
            Tã dán Rumi đạt chứng nhận tiêu chuẩn <strong>SGS</strong> &{" "}
            <strong>TCVN 10584:2014</strong>.
          </p>
          <div className="nbx-cta">
            <button
              type="button"
              onClick={() => {
                props.onOpen();
              }}
              className="btn btn-gradient"
            >
              Certificate
            </button>
          </div>
        </div>

        {/* subtle deco */}
      </section>

      {/* GALLERY 3 ảnh */}
      <section className="nbx-gallery container">
        <img src="/images/proper/gl1.jpg" alt="newborn 1" />
        <img src="/images/proper/gl2.jpg" alt="newborn 2" />
        <img src="/images/proper/gl3.jpg" alt="newborn 3" />
      </section>

      {/* QUOTE BAND */}
      <section className="nbx-quote">
        <div className="container">
          <p className="nbx-sub">NEWBORN RUMI</p>
          <p className="nbx-sub">
            <strong> ÊM ÁI, THOÁNG KHÍ, AN TOÀN CHO BÉ SƠ SINH </strong>
          </p>
          <blockquote>
            Tã dán Newborn Rumi đạt chứng nhận tiêu chuẩn SGS và TCVN
            10584:2014, được sản xuất theo quy trình hiện đại đạt chuẩn FDA, đảm
            bảo an toàn tuyệt đối cho làn da nhạy cảm của bé. Lấy cảm hứng từ Cụ
            Rùa ngàn năm Hồ Gươm – biểu tượng của sự chở che và tình yêu thuần
            khiết, Rumi khắc họa hình ảnh thiên thần nhỏ trong bộ mai rùa nằm
            trên mây, gửi gắm thông điệp yêu thương Việt đến từng em bé. Với bề
            mặt vân 3D thoáng khí, chất vải dệt nhiệt siêu mềm và rãnh rốn Oheso
            viền mềm mại, Rumi giúp bảo vệ cuống rốn bé luôn khô ráo, êm ái. Lõi
            thấm 5 lớp SAP siêu mỏng chỉ 1,5mm thấm hút nhanh, chống thấm ngược
            hiệu quả, kết hợp cùng vách chống tràn cao 5cm ôm sát và miếng dán
            linh hoạt, vạch báo ướt tiện lợi, mang đến cho mẹ trải nghiệm chăm
            con gọn gàng, nhẹ nhàng và an tâm hơn mỗi ngày.
          </blockquote>
        </div>
      </section>

      <section className="nbx-split container reverse">
        <div className="nbx-col nbx-photo">
          <img src="/images/material/be_mat.jpg" alt="lop be mat" />
          <div className="nbx-badge mint">Vải dệt nhiệt siêu mềm</div>
        </div>
        <div className="nbx-col nbx-text">
          <h2 className="hd border-bottom">Lớp Bề Mặt</h2>
          <p>
            Bề mặt tã vân 3D với 5000 lỗ thoáng làm giảm điểm tiếp xúc, giúp bề
            mặt siêu thoáng khí.
          </p>
          <p>
            Chất liệu vải dệt nhiệt siêu mềm mịn nên khi tiếp xúc với da không
            cọ xát khiến con khó chịu hay làm tấy đỏ da.
          </p>
        </div>
      </section>

      <section className="nbx-split container reverse">
        <div className="nbx-col nbx-text">
          <h2 className="hd border-bottom">
            Rãnh Rốn
            <span>
              <img src="/images/material/sun.png" alt="cloud" className="sun" />
            </span>
          </h2>
          <p>
            Rãnh rốn Oheso viền mềm mại, ôm xung quanh cuống rốn, giúp cuống rốn
            của trẻ được hạn chế tiếp xúc với chất bẩn, khô thoáng và nhanh rụng
            hơn.
          </p>
        </div>
        <div className="nbx-col nbx-photo">
          <img src="/images/material/ranhron.jpg" alt="ranh ron oheso" />
          <div className="nbx-badge mint">Rãnh rốn Oheso</div>
        </div>
      </section>

      {/* FEATURES – so le ảnh & chữ */}

      <section id="features" className="nbx-split container loitham">
        <div className="nbx-col nbx-text">
          <h2 className="hd border-bottom">Lớp Lõi Thấm</h2>

          <p>
            Lõi thấm có cấu tạo 5 lớp với hàm lượng cao các hạt SAP, giúp thấm
            hút cực nhanh và chống thấm ngược ngay lập tức sau khi thấm hút.
          </p>

          <img
            src="/images/material/5lop.jpg"
            alt="cau tao"
            className="cau_tao"
          />
          <div className="nbx-badge">
            Thấm hút cực nhanh và chống thấm ngược
          </div>
        </div>
        <div className="nbx-col nbx-text backarea">
          <p>
            Công nghệ sản xuất hiện đại nhất hiện nay giúp sản phẩm đạt được độ
            siêu mỏng (chỉ 1,5mm) và siêu nhẹ.
          </p>
          <img
            src="/images/material/15.jpg"
            alt="mong 1,5mm"
            className="cau_tao"
          />
          <div className="nbx-badge">Siêu mỏng chỉ 1,5mm</div>
        </div>
      </section>

      <section className="nbx-split container reverse">
        <div className="nbx-col nbx-photo">
          <img
            src="/images/material/vach_chong_tran.jpg"
            alt="vach_chong_tran"
          />
          <div className="nbx-badge mint">Vách chống tràn 5cm</div>
        </div>
        <div className="nbx-col nbx-text">
          <h2 className="hd border-bottom">Vách chống tràn</h2>
          <p>
            <strong>Vách chống tràn 5cm </strong>
            được thiết kế hai bên ôm sát đùi, đảm bảo chống tràn tuyệt đối, giúp
            bé vận động linh hoạt đồng thời không gây hại cho chân bé.
          </p>
          <p>
            Vạch chỉ báo mức nước tiểu giúp mẹ dễ theo dõi và thay tã cho bé.
          </p>
          <p>
            Miếng dán hai bên tã giúp mẹ dễ dàng cố định bỉm cho bé và cuộn lại
            gọn gàng sau khi sử dụng.
          </p>
        </div>
      </section>

      {/* GUIDE */}
      <section id="guide" className="nbx-card nbx-split container">
        <div className="nbx-col nbx-text">
          <h2 className="hd border-bottom">Hướng dẫn sử dụng</h2>
          <p>
            Để thay tã cho bé, ba mẹ hãy tham khảo và làm theo các bước sau:
          </p>

          <p>
            <strong>Bước 1: Chuẩn bị bỉm</strong>
          </p>
          <p>
            Lấy miếng bỉm ra, nhẹ nhàng kéo căng để định hình và dựng vách chống
            tràn hai bên. Việc này giúp bỉm ôm khít hơn và hạn chế rò rỉ khi bé
            tè.
          </p>

          <p>
            <strong>Bước 2: Đặt bỉm</strong>
          </p>
          <p>
            Đặt bỉm trực tiếp dưới mông bé, nhẹ nhàng kéo phần thân trước của
            bỉm lên đến ngang rốn. Đây là vị trí vừa vặn để bé thoải mái, không
            bị cấn bụng cũng như không quá lỏng lẻo.
          </p>

          <p>
            <strong>Bước 3: Cố định bỉm</strong>
          </p>
          <p>
            Ấn nhẹ phần mép bỉm xuống, sau đó kéo và dán hai miếng băng dính ở
            hai bên. Dán cân đối, vừa vặn để bỉm ôm sát bụng bé nhưng không quá
            chặt, giúp con dễ chịu và dễ thở.
          </p>

          <p>
            <strong>Bước 4: Hoàn thiện và điều chỉnh</strong>
          </p>
          <p>
            Cuối cùng, chỉnh lại phần chun bên trong bỉm để ôm gọn đùi bé. Đây
            là chi tiết nhỏ nhưng rất quan trọng để ngăn chất lỏng tràn ra
            ngoài, giữ cho bé luôn khô thoáng.
          </p>
        </div>
        <div className="nbx-col nbx-photo">
          <img
            className="nb_thayta"
            src="/images/material/thaytadan.jpg"
            alt="huong dan thay ta"
          />
          <div className="nbx-badge">Hướng dẫn thay tã Newborn</div>
        </div>
      </section>

      {/* CTA */}
      <section id="buy" className="nbx-ctaBand">
        <div className="container">
          <h3>Bạn muốn mua tại shop?</h3>
          <Link to="/shop" className="btn btn-gradient large">
            Tìm Shop
          </Link>
        </div>
      </section>
    </main>
  );
}
